/**
 * Resource danh mục định khoản tự động
 * ntduong2 24/4/2023
 */
export default {
  Title: 'Định khoản tự động',
  Dictionary: 'Danh mục',
  FolderPath: '/ Tài khoản / Định khoản tự động',
  AutoBusinessCode: 'Mã định khoản *',
  AutoBusinessName: 'Tên định khoản *',
  RefType: 'Chứng từ',
  CashWithDrawType: 'Nghiệp vụ',
  DebitAccount: 'TK Nợ',
  DebitAccountTitle: 'Tài khoản nợ',
  CreditAccount: 'TK Có',
  CreditAccountTitle: 'Tài khoản có',
  Description: 'Diễn giải',
};
